import * as React from "react";
import { useTranslation } from "react-i18next";

import style from "./news.scss";
import LeftArrow from "components/icons/LeftArrow";
import { NewsPage } from "services/news/NewsService";
import { getInitials } from "utils/format";
import { useTheme } from "utils/useTheme";

interface NewsDetailProps {
    newsItem: NewsPage;
    onBack: () => void;
    authorName?: string;
    dateLabel?: string;
    readTime?: number;
    title?: string;
}

const NewsDetail = ({ newsItem, onBack, authorName, dateLabel, readTime, title }: NewsDetailProps): JSX.Element => {
    const { t } = useTranslation();
    const theme = useTheme();
    const titleRef = React.useRef<HTMLHeadingElement>(null);
    const [titleWidth, setTitleWidth] = React.useState(0);
    const displayTitle = title || newsItem.title;

    React.useEffect(() => {
        if (titleRef.current) {
            setTitleWidth(titleRef.current.offsetWidth);
        }
    }, [displayTitle]);

    return (
        <div className={style.newsDetailContainer}>
            <button onClick={onBack}>
                <LeftArrow color={theme.iconFillColor} />
            </button>
            <article className={style.newsDetailArticle}>
                <h1 ref={titleRef}>{displayTitle}</h1>
                <div className={style.titleUnderline} style={{ width: `${titleWidth}px` }} />
                {(authorName || dateLabel || readTime) && (
                    <p className={style.newsMeta}>
                        {authorName && (
                            <>
                                {t("Routes.news.by")}
                                <span className={style.authorInfo}>
                                    <span className={style.authorInitial}>{getInitials(authorName)}</span>
                                    <span className={style.authorName}>{authorName}</span>
                                </span>
                            </>
                        )}
                        {dateLabel && <> • {dateLabel}</>}
                        {readTime && (
                            <>
                                {" "}
                                • {readTime} {t("Routes.news.readTime")}
                            </>
                        )}
                    </p>
                )}
                {newsItem.body?.view?.value && (
                    <div className={style.newsContent} dangerouslySetInnerHTML={{ __html: newsItem.body.view.value }} />
                )}
            </article>
        </div>
    );
};

export default NewsDetail;
